/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BeneficialOwnerPEPCopy } from './beneficial-owner-pep-copy';

export interface BeneficialOwnerPEPCopyResponse {
  readonly copies: Array<BeneficialOwnerPEPCopy>;
  readonly message: string;
}
